import React from 'react';

export const WizardProgressBar = ({ stepLabel, progressPercentage, completeSuffix }) => (
  <div className="mb-8">
    <div className="flex items-center justify-between mb-2">
      <span className="text-sm font-medium text-gray-700">{stepLabel}</span>
      <span className="text-sm text-gray-500">
        {Math.round(progressPercentage)}{completeSuffix}
      </span>
    </div>
    <div className="w-full h-2 bg-gray-200 rounded-full overflow-hidden">
      <div
        className="h-full bg-blue-900 transition-all duration-300"
        style={{ width: `${progressPercentage}%` }}
      />
    </div>
  </div>
);
